"use strict";

$(document).ready(function () {
  if ($('.product_slider_block').length > 0) {
    productSliderBlock();
  }

  if ($('#product .content.description_content').length > 0) {
    if ($('#product .content.description_content .product-description p iframe').length > 0) {
      var iframe = $('#product .content.description_content .product-description p iframe');
      var iframeWrapper = iframe.parents('p');
      iframeWrapper.addClass('iframeWrapper');
      var p_el_all = $('#product .content.description_content .product-description p');
      var p_el = $('#product .content.description_content .product-description p').not(iframeWrapper);
      $('#product .content.description_content .product-description').addClass('product-description-wrapper');
      p_el.wrapAll("<div class='product-description-textBlock' />");
      iframeWrapper.wrapAll("<div class='product-description-iframeBlock' />");
    }
  }

  if ($('#product .image_gallery_wrapper .swiper-container.inner_product_gallery .swiper-slide').length > 0) {
    $('#product .image_gallery_wrapper .swiper-container.inner_product_gallery .swiper-slide').each(function () {
      $(this).zoom();
    });
  }

  $(document).on('click', '.label-color.radio_container', function () {
    setTimeout(function () {
      $('#product .image_gallery_wrapper .swiper-container.inner_product_gallery .swiper-slide').each(function () {
        $(this).zoom();
      });
      $('.quickview .image_gallery .swiper-container.inner_product_gallery .swiper-slide').each(function () {
        $(this).zoom();
      });
    }, 800);
  }); // $('.open_popup.quick-view').click(function(){
  //     setTimeout(function () {
  //         $('.quickview .image_gallery .swiper-container.inner_product_gallery .swiper-slide').each(function () {
  //             $(this).zoom();
  //         });
  //     }, 800);
  // });
});

function productSliderBlock() {
  var breakpoint = window.matchMedia('(max-width: 1151px)');
  var mySwiper;

  var breakpointChecker = function breakpointChecker() {
    if (breakpoint.matches === true) {
      if (mySwiper !== undefined) {
        mySwiper.destroy(true, true);
      }

      return;
    } else if (breakpoint.matches === false) {
      return enableSwiper();
    }
  };

  var enableSwiper = function enableSwiper() {
    var slider = $('.product_slider_block .swiper-featured-products');
    slider.each(function () {
      var t = $(this);
      var next = t.parents('.product_slider_block').find('.swiper-button-next');
      var prev = t.parents('.product_slider_block').find('.swiper-button-prev');
      mySwiper = new Swiper(t, {
        slidesPerView: 4,
        watchSlidesProgress: true,
        navigation: {
          nextEl: next,
          prevEl: prev
        }
      });
    });
  };

  breakpoint.addListener(breakpointChecker);
  breakpointChecker();
}